import { BilledEventType } from '@/api/v1/opco/events/getBilledEventsApi';
import { DEFAULT_FILTER_PARAMS, FilterParamsType, QueryParamsType } from '@/api/helpers/apiParamsHelpers';
import { ApiParams, prepareBaseListApiParams } from '@/api/helpers/apiHelpers';
import { WIRE_TYPE_SINGULAR_LABEL } from '@/const/wire';

export type BilledEventTableRowType = {
  id: string;
  organizationName: string;
  viewDate: string;
  wireName: string;
  wireId: string;
  billableUser: string;
  transactionName: string;
  wireType: string;
  is_kyc_required?: boolean;
};

export const getBilledEventsList = (billedEvents: BilledEventType[] = []): BilledEventTableRowType[] => {
  return billedEvents.map(({ id, date_created, wire, user, organization, is_kyc_required }) => {
    return {
      id,
      organizationName: organization?.name,
      viewDate: date_created,
      wireName: wire?.name,
      wireId: wire?.ref_id,
      billableUser: user?.email,
      transactionName: wire?.contract?.name,
      wireType: WIRE_TYPE_SINGULAR_LABEL[wire?.type],
      is_kyc_required,
    };
  });
};

export const prepareBillingSearchFiltersListApiParams = (queryParams?: QueryParamsType): ApiParams => {
  const baseParams = prepareBaseListApiParams(queryParams);

  const params = { ...baseParams };

  if (queryParams.filters) {
    const filterValues: FilterParamsType = queryParams.filters;
    const filterNames = Object.keys(DEFAULT_FILTER_PARAMS);

    filterNames.forEach((filterName) => {
      const value = filterValues[filterName];

      if (value) {
        params[filterName] = Array.isArray(value) ? value.map((item) => item?.value || item).join(',') : value;
      }
    });
  }

  if (queryParams.search) {
    params.search = queryParams.search;
  }

  return params;
};
